import LogoutTimer from './LogoutTimer';

export default LogoutTimer;
